/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Show_Hide_TimelineInputs */

const en_show_hide_timeline = /** @type {(inputs: Show_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show/Hide Timeline`)
};

const fr_show_hide_timeline = /** @type {(inputs: Show_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher/Masquer la ligne de temps`)
};

const de_show_hide_timeline = /** @type {(inputs: Show_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitleiste ein-/ausblenden`)
};

const it_show_hide_timeline = /** @type {(inputs: Show_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra/Nascondi cronologia`)
};

const ru_show_hide_timeline = /** @type {(inputs: Show_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать/скрыть временную шкалу`)
};

const es_show_hide_timeline = /** @type {(inputs: Show_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar/ocultar la línea de tiempo`)
};

const zh_cn2_show_hide_timeline = /** @type {(inputs: Show_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示/隐藏时间线`)
};

const ja_show_hide_timeline = /** @type {(inputs: Show_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムラインの表示/非表示`)
};

const hi_show_hide_timeline = /** @type {(inputs: Show_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमलाइन दिखाएँ/छिपाएँ`)
};

const pt_pt2_show_hide_timeline = /** @type {(inputs: Show_Hide_TimelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar/Ocultar Linha do Tempo`)
};

/**
* | output |
* | --- |
* | "Show/Hide Timeline" |
*
* @param {Show_Hide_TimelineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const show_hide_timeline = /** @type {((inputs?: Show_Hide_TimelineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_Hide_TimelineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_show_hide_timeline(inputs)
	if (locale === "de") return de_show_hide_timeline(inputs)
	if (locale === "it") return it_show_hide_timeline(inputs)
	if (locale === "ru") return ru_show_hide_timeline(inputs)
	if (locale === "es") return es_show_hide_timeline(inputs)
	if (locale === "zh-CN") return zh_cn2_show_hide_timeline(inputs)
	if (locale === "ja") return ja_show_hide_timeline(inputs)
	if (locale === "hi") return hi_show_hide_timeline(inputs)
	if (locale === "pt-PT") return pt_pt2_show_hide_timeline(inputs)
	return en_show_hide_timeline(inputs)
});